window.FormActions = Reflux.createActions([
  "submit",
  "success",
  "error",
  "reset"
]);

module.exports = FormActions;